export const getIdentificationData = () => {
  const storageVariables = sessionStorage.getItem("activeAccount") || "{}";
  try {
    const storageObject = JSON.parse(storageVariables);
    return {
      token: `Bearer ${storageObject?.idToken || ""}`,
      employeeId: storageObject?.idTokenClaims?.employeeid || "",
    };
  } catch {
    return {
      token: `Bearer `,
      employeeId: "",
    };
  }
};
